export class Programa {
    constructor(id, codigo, launcher, descripcion, codigoPantalla) {
        this.id = id;
        this.codigo = codigo;
        this.launcher = launcher;
        this.descripcion = descripcion;
        this.codigoPantalla = codigoPantalla;
    }
}


// WEBPACK FOOTER //
// ./Portico/App/Common/Programa.js